<template>
  <div class="select-box">
    <div class="select-item-box item1">
      <div @click="chooseAll()">全部</div>
      <div :class="{active:selected1Code.indexOf(t1.orgCode)!==-1}" v-for="t1 in items"
           :key="t1.orgCode"
           @click="item1Click(t1)"
      >{{t1.orgSname}}</div>
    </div>
    <div v-if="filterType==='branch'" class="select-item-box" :style="{width:filterType==='product'?'66%':'33%'}">
      <div class="chooseAll" @click="chooseAllSecond()">全选</div>
      <div v-show="item2Show" class="item3" :class="{active:selected2Code.indexOf(t2.orgCode)!==-1}" v-for="t2 in items2"
           :key="t2.orgCode"
           @click="item2Click(t2)"
      >
        <span>{{t2.orgSname}}</span>
        <span :style="{visibility:selected2Code.indexOf(t2.orgCode)!==-1?'unset':'hidden'}">
          <van-icon name="success"  color="#3399FF"/>
        </span>
      </div>
    </div>
    <div v-if="filterType==='product'" class="select-item-box" :style="{width:filterType==='product'?'66%':'33%'}">
      <div class="item3" v-show="item2Show" :class="{active:selected2Code.indexOf(t2.orgCode)!==-1}" v-for="t2 in items2"
           :key="t2.orgCode"
           @click="item2Click(t2)"
      >
        <span>{{t2.orgSname}}</span>
        <span :style="{visibility:selected2Code.indexOf(t2.orgCode)!==-1?'unset':'hidden'}">
          <van-icon name="success"  color="#3399FF"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProductTreeSelect',
  data () {
    return {
      items2: [],
      items3: [],
      item2Show: false,
      item3Show: false,
      selected1: {},
      selected2: {},
      selected3: {},
      selected1Code: [],
      selected2Code: [],
      selected3Code: [],
      choose1: {},
      choose2: {},
      newDataT1: [], // 一级数据接收器
      newDataT2: [] // 二级数据接收器
    }
  },
  props: {
    items: {
      type: Array,
      require: true
    },
    filterType: {
      type: String,
      require: true
    },
    type: {
      type: String,
      require: true
    }
  },
  methods: {
    item1Click (t1) { // 点击一级
      this.choose1 = t1
      // 监听是否取消选中，删除被选中项
      if (this.selected1Code.indexOf(t1.orgCode) !== -1) {
        // 存储要删除的1级数据
        var seleDelete = JSON.parse(JSON.stringify(t1))
        var newChoose2 = []
        newChoose2.push(seleDelete)
        delete this.selected1[t1.orgCode]
        // delete this.selected1[t1.children]
        // 筛选删除被取消项
        for (let i = 0; this.newDataT1.length > i; i++) {
          if (this.newDataT1[i].orgCode === t1.orgCode) {
            this.newDataT1.splice(i, 1)
          }
        }
        // 刷选删除包含二级数据
        for (let n = 0; newChoose2[0].children.length > n; n++) {
          for (let m = 0; this.newDataT2.length > m; m++) {
            if (this.newDataT2[m].orgCode === newChoose2[0].children[n].orgCode) {
              this.newDataT2.splice(m, 1)
            }
          }
        }
        this.selected1Code.splice(this.selected1Code.indexOf(t1.orgCode), 1)
        this.item2Show = false
        this.item3Show = false
        if (this.selected1Code.length > 0) {
          this.items2 = this.selected1[this.selected1Code[0]].children
          this.item2Show = true
        }
        let codes = []
        for (let key in this.selected2) {
          let item = this.selected2[key]
          if (item.parentId === t1.orgCode) {
            delete this.selected2[key]
            this.selected2Code.splice(this.selected2Code.indexOf(item.orgCode), 1)
            codes.push(item.orgCode)
          }
        }
        if (this.selected2Code.length > 0) {
          this.items3 = this.selected2[this.selected2Code[0]].children
          this.item3Show = true
        }
        for (let key in this.selected3) {
          let x = this.selected3[key]
          if (codes.indexOf(x.parentNode) !== -1) {
            delete this.selected3[key]
            this.selected3Code.splice(this.selected3Code.indexOf(x.orgCode), 1)
          }
        }
      } else {
        this.selected1Code.push(t1.orgCode)
        this.selected1[t1.orgCode] = t1
        this.newDataT1.push(t1) // 被选中的值
        if (t1.children) {
          this.items2 = t1.children
          this.item2Show = true
          this.item3Show = false
          // this.selected1[t1.orgCode] = t1
          // this.selected1Code.push(t1.orgCode)
          // 选中的一级发送到父级组件
        } else {
          this.items2 = []
        }
      }
      if (JSON.stringify(this.selected1) === '{}') {
        this.newDataT1 = []
        this.newDataT2 = []
        if (this.type === 'organization') {
          this.$emit('chooseData2', this.newDataT2)
        } else {
          this.$emit('chooseMasterData2', this.newDataT2)
        }
      }
      if (this.type === 'organization') {
        this.$emit('chooseData1', this.newDataT1) // 将被选中的值传到父级
      } else {
        this.$emit('chooseMasterData1', this.newDataT1)
      }
    },
    item2Click (t2) { // 点击二级
      this.choose2 = t2
      if (this.selected2Code.indexOf(t2.orgCode) !== -1) {
        delete this.selected2[t2.orgCode]
        // 删除已有的选择目录2
        for (let i = 0; this.newDataT2.length > i; i++) {
          if (this.newDataT2[i].orgCode === t2.orgCode) {
            this.newDataT2.splice(i, 1)
          }
        }
        this.selected2Code.splice(this.selected2Code.indexOf(t2.orgCode), 1)
      } else {
        this.selected2[t2.orgCode] = t2
        this.selected2Code.push(t2.orgCode)
        this.newDataT2.push(t2)
      }
      // this.$emit('chooseData2', this.selected2)
      // 选中的二级发送到父级组件
      if (this.type === 'organization') {
        this.$emit('chooseData2', this.newDataT2)
      } else {
        this.$emit('chooseMasterData2', this.newDataT2)
      }
    },
    chooseAll () { // 全选一级目录
      if (this.selected1Code.length === this.items.length) {
        this.selected1 = {}
        this.selected1Code = []
        this.newDataT1 = []
        this.newDataT2 = []
        this.selected2 = {}
        this.selected2Code = []
        if (this.type === 'organization') {
          this.$emit('chooseData2', this.newDataT2)
        } else {
          this.$emit('chooseMasterData2', this.newDataT2)
        }
      } else {
        this.selected1 = {}
        this.selected1Code = []
        for (let i = 0; i < this.items.length; i++) {
          this.selected1[this.items[i].orgCode] = this.items[i]
          this.selected1Code.push(this.items[i].orgCode)
        }
        this.newDataT1 = JSON.parse(JSON.stringify(this.items))
      }
      this.item2Show = false
      if (this.type === 'organization') {
        this.$emit('chooseData1', this.newDataT1)
      } else {
        this.$emit('chooseMasterData1', this.newDataT1)
      }
    },
    chooseAllSecond () { // 全选二级目录
      if (this.items2.length === 0) { return } // 2级没有数据直接返回
      // 先判断已选的数据中是否有 已经跟目前items2展示的数据都选中了
      let j = 0
      for (let i = 0; i < this.items2.length; i++) {
        if (this.selected2Code.indexOf(this.items2[i].orgCode) !== -1) {
          j++
        }
      }
      // 如果选中了 那么清除所有选中的当前数据
      if (j === this.items2.length) {
        for (let q = 0; q < this.items2.length; q++) {
          this.selected2Code.splice(this.selected2Code.indexOf(this.items2[q].orgCode), 1)
          delete this.selected2[this.items2[q].orgCode]
          for (let w = 0; w < this.newDataT2.length; w++) {
            if (this.selected2Code.indexOf(this.newDataT2[w].orgCode) !== -1) {
              this.newDataT2.splice(this.selected2Code.indexOf(this.newDataT2[w].orgCode), 1)
            }
          }
        }
      } else {
        // 将未选择的部分增加到选中当中
        for (let q = 0; q < this.items2.length; q++) {
          if (this.selected2Code.indexOf(this.items2[q].orgCode) === -1) {
            this.selected2Code.push(this.items2[q].orgCode)
            this.selected2[this.items2[q].orgCode] = this.items2[q]
            this.newDataT2.push(this.items2[q])
          }
        }
      }
      if (this.type === 'organization') {
        this.$emit('chooseData2', this.newDataT2)
      } else {
        this.$emit('chooseMasterData2', this.newDataT2)
      }
    },
    clearConditions () {
      this.selected1 = {}
      this.selected1Code = []
      this.selected2 = {}
      this.selected2Code = []
      this.newDataT2 = []
      this.newDataT1 = []
      this.items2 = []
      this.item2Show = false
      // this.$emit('chooseData2', this.newDataT2)
      // this.$emit('chooseMasterData2', this.newDataT2)
      // this.$emit('chooseData1', this.newDataT1)
      // this.$emit('chooseMasterData1', this.newDataT1)
      // if (this.type === 'organization') {
      //   this.$emit('chooseData2', this.newDataT2)
      // } else {
      //   this.$emit('chooseMasterData2', this.newDataT2)
      // }
      // if (this.type === 'organization') {
      //   this.$emit('chooseData1', this.newDataT1)
      // } else {
      //   this.$emit('chooseMasterData1', this.newDataT1)
      // }
    },
    clearMasterTree () {
      this.$emit('chooseMasterData2', this.newDataT2)
      this.$emit('chooseMasterData1', this.newDataT1)
    },
    clearTree () {
      this.$emit('chooseData1', this.newDataT1)
      this.$emit('chooseData2', this.newDataT2)
    }
  },
  created () {
    this.$emit('itemsClik', this.$props.items)
  },
  watch: {
    choose1 () {
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-box{
  display: flex;
  justify-content: start;
  align-content: stretch;
  box-sizing: border-box;
}
.select-item-box{
  width:50% !important;
  box-sizing: border-box;
  /*border:1px solid #ddd;*/
}
.select-item-box>div{
  padding: .1rem 0;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  color:#999;
  font-weight normal
}
.select-item-box>div.active{
  font-weight: 600;
  color: #333;
}
.item1>div{
  background-color: #F3F5F9;
}
.item1>div.active{
  position: relative;
  background-color: #fff;

}
.item1>div.active::before{
  display: inline-block;
  content: '';
  border-left: .02rem solid #3399FF;
  left: 0;
  top: 15%;
  height:70%;
  position: absolute;
}
.item3{
  display:flex;
  justify-content: space-around;
  align-items:center;
}
.item3>span:last-child{
  flex-grow:1;
}
.item3>span:first-child{
  text-overflow: ellipsis;
  overflow:hidden;
  flex-grow:3;
}
// .select-item-box .chooseAll{
//   text-align left
//   padding-left .1rem
// }
</style>



// WEBPACK FOOTER //
// src/pages/common/analyseScreen/ProductTreeSelect.vue